// extracted by mini-css-extract-plugin
export default {"Reports":"Reports_Reports__87hI-","item":"Reports_item__kHD9E"};